import React from 'react';

import { classnames, margin } from '@lumapps/classnames';
import { SelectTextField } from '@lumapps/combobox/components/SelectTextField';
import { Checkbox, Heading } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { WIDGET_PLAYLIST } from '../../../keys';
import { WidgetPlaylistProperties } from '../../../types';

export type PlaylistOptionsProperties = Pick<WidgetPlaylistProperties, 'itemsPerLine' | 'slideshowEnabled'>;

export interface PlaylistOptionsProps {
    className?: string;
    properties: PlaylistOptionsProperties;
    onChange: (properties: PlaylistOptionsProperties) => void;
}

const CLASSNAME = 'playlist-options';

/**
 *
 * @param PlaylistOptionsProps
 * @returns PlaylistOptions
 */
export const PlaylistOptions = ({ className, properties, onChange }: PlaylistOptionsProps) => {
    const { translateKey } = useTranslate();
    const { slideshowEnabled, itemsPerLine } = properties;

    return (
        <div className={classnames(className, CLASSNAME)}>
            {/* eslint-disable-next-line react/forbid-elements */}
            <Heading as="h4" typography="subtitle1" className={margin('bottom', 'huge')}>
                {translateKey(GLOBAL.OPTIONS)}
            </Heading>
            <Checkbox
                className={margin('bottom', 'regular')}
                role="checkbox"
                isChecked={slideshowEnabled}
                label={translateKey(WIDGET_PLAYLIST.SLIDESHOW_ENABLED)}
                onChange={(value) => onChange({ ...properties, slideshowEnabled: value })}
            />

            <SelectTextField<number>
                autoFilter={false}
                selectionType="single"
                hasClearButton={false}
                value={itemsPerLine || 3}
                label={translateKey(WIDGET_PLAYLIST.SETTINGS_MAX_VIDEOS_PER_LINE)}
                options={Array.from({ length: 5 }, (_, i) => i + 1)}
                helper={translateKey(WIDGET_PLAYLIST.SETTINGS_MAX_VIDEOS_PER_LINE_HELPER)}
                getOptionId={(value) => `${value}`}
                onChange={(value) => value && onChange({ ...properties, itemsPerLine: value })}
            />
        </div>
    );
};
